import {t} from "i18next";
import {stringToNumberLocale, stringToPercentage} from "./formatter";

let errorReportNameList = [];

export const isEmptyObject = obj => (Object.keys(obj).length === 0);

export const billingReportsDataParams = args => ({
  year: args.year,
  duration: args.duration,
  oem_id: args.oem_id,
  period: args.period,
  region_name: args.region_name,
  output_type: 'csv'
});

export const contractFilterParams = args => ({
  aggregate_by: args.aggregate_by,
  end_date: args.end_date,
  oem_id: args.oem_id,
  oem_model: args.oem_model,
  region_name: args.region_name,
  start_date: args.start_date
});

export const getErrorReportNames = errors => {
  errorReportNameList = [];
  errors.map((key) => {
    if (key.url) {
      errorReportNameList.push(key.url.split('?')[1].split('&')[0].split('=')[1]);
    }
    return false;
  });
};

// data: response, reportName: original report name, formatter: formatting the data
export const getReportData = (data, reportName, formatter) => {
  if (errorReportNameList.includes(reportName) || (data && data.hasOwnProperty('message'))) {
    return t('unableToFetchData');
  } else if (data === t('notComputable')) {
    return t('notComputable');
  } else if (data && (formatter !== undefined)) {
    return (formatter === 'stringToPercentage') ? stringToPercentage(data) : stringToNumberLocale(data);
  } else {
    return data;
  }
};

export const convertCsvToString = (csvData) => {
  if (csvData) {
    if (csvData === 'No data available for this report') {
      return csvData;
    } else {
      // Step 1: Split the string into fields
      const fields = csvData.split(' ');

      // Step 2: Determine the number of columns (from the first row, assuming no extra spaces)
      const columnCount = fields[0].split(',').length;

      // Step 3: Group fields into rows based on the column count
      let rows = [];
      for (let i = 0; i < fields.length; i += columnCount) {
        rows.push(fields.slice(i, i + columnCount).join(','));
      }

      // Step 4: Join rows with a newline character
      return rows.join('\n');
    }
  }
};

export const convertCsvToArrayOfObject = (csvData) => {
  if (csvData) {
    if (csvData === 'No data available for this report') {
      return csvData;
    } else {
      const rows = csvData.split('\n');

      // Extract headers from the first row
      const headers = rows[0].split(',');

      // Convert remaining rows into array of objects
      const arrayData = rows.slice(1).map(row => {
        const values = row.split(',');
        return headers.reduce((obj, header, index) => {
          obj[header] = values[index];
          return obj;
        }, {});
      });

      return arrayData;
    }
  }
};
